import { useEffect, useState } from 'react';

export const useOutsideClick = (
	refs: React.MutableRefObject<null | HTMLElement>[],
	handler: () => void
) => {
	useEffect(() => {
		function handleClickOutside({ target }: MouseEvent) {
			const elements = [];
			for (const ref of refs) {
				if (ref.current && ref.current.contains(target as Node)) {
					elements.push(ref);
				}
			}

			if (elements.length === 0) {
				handler();
			}
		}

		// Bind the event listener
		document.addEventListener('mousedown', handleClickOutside);
		return () => {
			// Unbind the event listener on clean up
			document.removeEventListener('mousedown', handleClickOutside);
		};
	}, [refs, handler]);
};

export const useCommonMenu = () => {
	const [referenceEl, setReferenceEl] = useState<HTMLElement | null>(null);
	const [popperEl, setPopperEl] = useState<HTMLElement | null>(null);

	const onOpen = (e: React.MouseEvent<HTMLElement, MouseEvent>) => {
		e.preventDefault();
		e.stopPropagation();
		popperEl?.setAttribute('data-show', 'true');
		referenceEl?.setAttribute('data-show', 'true');
	};

	const onClose = (e: React.MouseEvent<HTMLElement, MouseEvent>) => {
		e.preventDefault();
		e.stopPropagation();
		popperEl?.setAttribute('data-show', 'false');
		referenceEl?.setAttribute('data-show', 'false');
	};

	return {
		referenceEl,
		setReferenceEl,
		popperEl,
		setPopperEl,
		onOpen,
		onClose,
	};
};
